import React from "react";
import { observer, inject } from "mobx-react";
import styled from "styled-components";

import { Box } from "grommet";
import { ChapterPrevious, ChapterNext } from "grommet-icons";

import Contents from "app/api/contents";
import Button from "app/components/Button";

const container = (component) => styled(component)`
  width: 32px;
  height: 32px;
  @media (max-width: 600px) {
    width: 20px;
    height: 20px;
  }
`;

const PreviousIcon = container(ChapterPrevious);
const NextIcon = container(ChapterNext);

function NavigationButtons({ AppState }) {
  if (AppState.isUserSearching) return null;
  return (
    <Box direction="row" justify="between" width="25%">
      <Button
        title="Previous Section"
        pad="small"
        justify="center"
        align="center"
        onClick={Contents.previousSection}
      >
        {Contents.hasPreviousSection() && <PreviousIcon color="accent-1" />}
      </Button>
      <Button
        title="Next Section"
        pad="small"
        justify="center"
        align="center"
        onClick={Contents.nextSection}
      >
        {Contents.hasNextSection() && <NextIcon color="accent-1" />}
      </Button>
    </Box>
  );
}

export default inject("AppState")(observer(NavigationButtons));



// WEBPACK FOOTER //
// ./src/app/components/MainMenu/NavigationButtons.js